import { PlusOutlinedIcon } from 'assets/images/icons';
import { Container } from 'common/ui/container';
import { IconButton } from 'common/ui/icon-button';
import { utilFormatDate } from 'common/utils';
import { AiVariant } from 'modules/mel-ai/types';
import { PropsWithChildren } from 'react';

import styles from './variant-item-wrapper.module.scss';

interface VariantItemWrapperProps extends PropsWithChildren {
  selectedVariantState: [AiVariant | null, React.Dispatch<React.SetStateAction<AiVariant | null>>];
  variant: AiVariant;
}

const VariantItemWrapper = ({
  children,
  selectedVariantState,
  variant,
}: VariantItemWrapperProps) => {
  const [selectedVariant, setSelectedVariant] = selectedVariantState;

  const isSelected = selectedVariant && selectedVariant.id === variant.id;

  return (
    <div className={styles.wrapper}>
      <Container
        border={{
          type: 'solid',
          variant: isSelected ? 'primary' : 'secondary',
        }}
        className={styles.container}
        withShadow={isSelected}
      >
        <div className={styles.header}>
          <p>{utilFormatDate(variant.created_at, { formatStr: 'd MMM yyyy h:mm aaaa' })}</p>
          <div className={styles.actions}>
            <IconButton
              buttonProps={{
                outlined: !isSelected,
                size: 'small',
                variant: 'primary',
              }}
              onClick={() => setSelectedVariant(variant)}
              type="button"
            >
              <PlusOutlinedIcon />
            </IconButton>
          </div>
        </div>
        <br />
        <div className={styles.children}>{children}</div>
      </Container>
    </div>
  );
};

export { VariantItemWrapper };
